// GlowParticles.jsx
import React, { useMemo } from 'react';
import { motion } from 'framer-motion';

/**
 * Subtle ambient life around the hardware: floating motes, tiny circuit dots and
 * a few sparks. Positions are deterministic (no random flashing). Overall
 * presence is gated by the energy level so the board feels dormant, then alive.
 *
 * @param {MotionValue} glow  0..1 master intensity
 */
function GlowParticles({ glow }) {
  const particles = useMemo(
    () => [
      { x: 210, y: 150, r: 2.2, d: 0.0, dur: 7 },
      { x: 430, y: 200, r: 1.6, d: 1.1, dur: 8 },
      { x: 300, y: 470, r: 2.6, d: 0.5, dur: 6.5 },
      { x: 150, y: 360, r: 1.8, d: 2.0, dur: 7.5 },
      { x: 470, y: 360, r: 2.0, d: 1.6, dur: 8.5 },
      { x: 380, y: 110, r: 1.5, d: 0.8, dur: 7 },
      { x: 250, y: 240, r: 1.7, d: 2.4, dur: 9 },
      { x: 560, y: 300, r: 2.1, d: 1.3, dur: 6.8 },
      { x: 190, y: 440, r: 1.5, d: 0.3, dur: 8.2 },
      { x: 410, y: 430, r: 1.9, d: 1.9, dur: 7.3 },
    ],
    []
  );

  const sparks = useMemo(
    () => [
      { x: 320, y: 175, d: 0.0 },
      { x: 455, y: 300, d: 0.6 },
      { x: 320, y: 425, d: 1.2 },
      { x: 512, y: 188, d: 0.9 },
      { x: 512, y: 412, d: 1.5 },
    ],
    []
  );

  return (
    <motion.g aria-hidden="true" style={{ opacity: glow }}>
      {particles.map((p, i) => (
        <circle
          key={`pt-${i}`}
          className="particle"
          cx={p.x}
          cy={p.y}
          r={p.r}
          fill="#A855F7"
          style={{ '--d': `${p.d}s`, '--dur': `${p.dur}s` }}
        />
      ))}

      {sparks.map((s, i) => (
        <g key={`sp-${i}`} className="spark" style={{ '--d': `${s.d}s` }}>
          <line x1={s.x - 5} y1={s.y} x2={s.x + 5} y2={s.y} stroke="#EDE4FF" strokeWidth="1.4" strokeLinecap="round" />
          <line x1={s.x} y1={s.y - 5} x2={s.x} y2={s.y + 5} stroke="#EDE4FF" strokeWidth="1.4" strokeLinecap="round" />
        </g>
      ))}
    </motion.g>
  );
}

export default React.memo(GlowParticles);
